import React from 'react';
import { useIntl } from 'react-intl';

import { Select } from '~/eds/src/components/Select/Select';
import { useDebouncedState } from '~/eds/src/hooks/useDebouncedState';
import { api } from '~/redux/api/createApi';

type ClientSelectProps = React.ComponentProps<typeof Select>;

export const ClientSelect = (props: ClientSelectProps) => {
  const intl = useIntl();
  const [debouncedSearch, _search, setSearch] = useDebouncedState('');
  const {
    data: clients = {
      results: [],
    },
    isFetching,
  } = api.endpoints.getClients.useQuery(
    {
      searchText: debouncedSearch,
    },
    {
      skip: !!props.value && !debouncedSearch,
    },
  );

  const allClients = clients?.results ?? [];

  const options = allClients.map((client) => ({
    label: intl.formatMessage(
      {
        id: 'ClientSelect.clientLabel',
        defaultMessage: '{clientName} ({clientId})',
        description:
          'Client label showing name and ID. Example: clientName = "Acme Corp", clientId = "123"',
      },
      {
        clientName: client.name,
        clientId: client.id,
      },
    ),
    value: client.id,
  }));

  return (
    <Select
      {...props}
      isLoading={isFetching}
      options={options}
      onSearch={(value) => {
        setSearch(value);
      }}
    />
  );
};
